import Cookie from 'js-cookie'
import Time from '~/common/time'


const PREFIX = 'SCRM_';

const CACHE_STRUCT = {
    value: null, // 存入缓存的值
    duration: 0 // 缓存持续时间
};

/**
 * 公用存储器
 * 当前使用Cookie作为存储容器
 */
export default {

    /**
     * 获取 Cookie 前缀Key
     * @param key
     * @returns {string}
     */
    getKey(key) {
        return PREFIX + key;
    },

    /**
     * 设置Cookie
     * @param key
     * @param value
     * @param duration
     */
    setCookie(key, value, duration) {

        if (parseInt(duration) == 0) {
            duration = 0;
        }

        let timestamp = Time.now() + duration;

        CACHE_STRUCT.value = value;
        CACHE_STRUCT.duration = timestamp;

        Cookie.set(this.getKey(key), JSON.stringify(CACHE_STRUCT));
        // Cookie.set(this.getKey(key), CACHE_STRUCT);
    },

    /**
     * 获取 Cookie 的值
     * @param key
     * @returns {*}
     */
    getCookie(key) {

        let cache = Cookie.get(this.getKey(key));
        if (cache) {
            try {
                cache = JSON.parse(cache); // 解析 JSON 字符串为对象
            } catch (e) {
                console.error('Failed to parse cookie JSON:', e);
                this.removeCookie(key); // 如果解析失败，删除无效的 Cookie
                return;
            }
        }

        let time = Time.now(); // 当前时间

        // 如果当前时间大于缓存有效时间则注销缓存返回空
        if (cache && parseInt(cache.duration) > 0 && cache.duration > time) {
            if (cache && cache.value) {
                return this.parseData(cache.value);
            }
        } else {
            // 缓存已过期失效从缓存中清除
            this.removeCookie(key);
        }

        return;
    },

    /**
     * 删除 Cookie
     * @param key
     * @returns {*}
     */
    removeCookie(key) {
        return Cookie.remove(this.getKey(key));
    },

    /**
     * 解析数据为JSON
     * @param {*} data 
     */
    parseData(data) {
        if (data && typeof data != 'object') {
            data = JSON.parse(data);
        }
        return data;
    },

    /**
     * 设置保存内容到Cookie
     * @param {*} key 
     * @param {*} value 
     * @param {*} duration 
     */
    set(key, value, duration) {
        return this.setCookie(key, value, duration);
    },

    /**
     * 从Cookie中读取内容
     * 当缓存超过有效时间时
     * @param {*} key 
     */
    get(key) {
        return this.getCookie(key);
    },

    /**
     * 删除指定Cookie内容
     * @param {*} key 
     */
    remove(key) {
        return this.removeCookie(key)
    },

    /**
     * 得到缓存数据
     * 不会触发因缓存持续时间过期而清除缓存
     * @param {*} key 
     */
    getCacheData(key) {
        let cache = Cookie.get(this.getKey(key));
        try {
            cache = this.parseData(cache);
        } catch (e) {
            console.error('Failed to parse cache JSON:', e);
            this.removeCookie(key); // 如果解析失败，删除无效的 Cookie
            return;
        }

        if (cache && cache.value) {
            return this.parseData(cache.value);
        } else {
            return;
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/storage.js